var map = {
    "es-es": "es-es",
    "ar-sa": "ar-sa",
    "en-us": "en-us",
    "de-de": "de-de",
    "in-id": "in-id",
    "it-it": "it-it",
    "fr-fr": "fr-fr",
    "iw-il": "iw-il",
    "ja-jp": "ja-jp",
    "ko-kr": "ko-kr",
    "ru-ru": "ru-ru",
    "pt-pt": "pt-pt",
    "nl-nl": "nl-nl",
    "th-th": "th-th",
    "vi-vn": "vi-vn",
    "tr-tr": "tr-tr",
    "zh-cn": "zh-cn",
    "zh-tw": "zh-tw"
};
var i18n = {
    "es-es": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "horas",
                "feedback.msgsend.control.stickLogin.email.must": "Introduzca su email.",
                "feedback.msgsend.control.fill.requirement": "Por favor introduzca sus requerimientos aquí.",
                "msgsend.control.mcSuccess.contactSupplier": "Contactar Proveedor",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Su mensaje debe tener entre 20 y 8000 caracteres.",
                "feedback.msgsend.control.privacy": "Facilitar mi  <span class=\"stress\">Tarjeta de Presentación</span>",
                "feedback.msgsend.whatyouneed": "Deja que los proveedores verificados correspondientes te encuentren.\n¡Simplemente dinos qué necesitas!",
                "feedback.msgsend.control.msgContent.msg.must": "Por favor, introduzca su mensaje",
                "feedback.msgsend.getquatation": "Obtener ofertas",
                "feedback.msgsend.control.industry.tip": "El vendedor podria necesitar esta información para darle un presupuesto preciso.",
                "feedback.msgsend.control.tipContent.view.sample": "Ver un ejemplo",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "Su consulta ha sido enviada con éxito al proveedor.",
                "feedback.msgsend.control.add": "Añadir",
                "feedback.msgsend.screen.memberInquiry.to": "Para",
                "feedback.msgsend.control.sku.limit": "Por favor introduzca entre 1 y 20",
                "feedback.msgsend.control.reply.within": "Respondame dentro de",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Por favor recomiéndame más proveedores seleccionados si este proveedor no me responde a través del Centro de Mensajes en un plazo de 24 horas.",
                "feedback.msgsend.screen.inquiry.from": "De",
                "feedback.msgsend.control.multilang.commit": "Contactar Vendedor",
                "feedback.msgsend.screen.inquiry.message": "Mensaje",
                "feedback.msgsend.control.msgQuantity.limit.number": "Introduzca una cifra.",
                "feedback.msgsend.control.msgQuantity.quantity": "Cantidad",
                "feedback.msgsend.screen.inquiry.message.info": "Introduzca la información de su consulta. Por ejemplo: el nombre del producto, el tamaño, el color, la cantidad mínima de pedido, el precio FOB, etc.",
                "feedback.msgsend.control.msgQuantity.limit.between": "Por favor introduzca entre 1 y 999999",
                "commons.button.submit": "Enviar"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "ar-sa": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "ساعات",
                "feedback.msgsend.screen.memberInquiry.to": "إلي",
                "feedback.msgsend.control.sku.limit": "يرجى ادخال بين 1-20 حرف",
                "feedback.msgsend.control.reply.within": "قم بالرد عليّ خلال",
                "feedback.msgsend.control.stickLogin.email.must": "ادخل بريدك.",
                "feedback.msgsend.control.fill.requirement": "يرجى كتابة أي متطلبات هنا.",
                "msgsend.control.mcSuccess.contactSupplier": "الاتصال بالمورد",
                "feedback.msgsend.control.msgContent.msg.char.limit": "يجب أن تكون رسالتك ما بين 20-8000 حرفا",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "من فضلك قم بتوصيتي بمزيد من الموردين المنتقين إذا لم يقم هذا المورد بالاتصال بي عبر \"مركز التراسل\" خلال 24 ساعة.",
                "feedback.msgsend.control.privacy": "أوافق على مشاركة </span>بطاقة العمل <span class=\"stress\"> الخاصة بي مع الموردين.",
                "feedback.msgsend.control.multilang.commit": "اتصل بالمورد",
                "feedback.msgsend.screen.inquiry.from": "من",
                "feedback.msgsend.screen.inquiry.message": "رسالة",
                "feedback.msgsend.whatyouneed": "دع الموردين المنشودين المؤكدين يعثرون عليك.       \nفقط أخبرنا بم تحتاج!",
                "feedback.msgsend.control.msgContent.msg.must": "الرجاء إدخال رسالتك",
                "feedback.msgsend.getquatation": "احصل على اقتباسات",
                "feedback.msgsend.control.msgQuantity.limit.number": "يرجي إدخال رقم.",
                "feedback.msgsend.control.msgQuantity.quantity": "الكمية",
                "feedback.msgsend.screen.inquiry.message.info": "أدخل تفاصيل الاستفسار مثل اسم المنتج واللون والحجم والحد الأدني للطلب وسعر الفوب",
                "feedback.msgsend.control.msgQuantity.limit.between": "يرجى ادخال بين 1-999999",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "تم ارسال تساؤلك بنجاح الى المزود.",
                "feedback.msgsend.control.tipContent.view.sample": "مشاهدة عينة",
                "feedback.msgsend.control.add": "إضافة",
                "commons.button.submit": "تقديم"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "en-us": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "hours",
                "feedback.msgsend.control.stickLogin.email.must": "Enter email or Member ID.",
                "feedback.msgsend.control.fill.requirement": "Please write your requirement here.",
                "msgsend.control.mcSuccess.contactSupplier": "Contact Supplier",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Your message must be between 20-8000 characters",
                "feedback.msgsend.control.privacy": "I agree to share my <span class=\"stress\">Business Card</span> to the supplier.",
                "feedback.msgsend.whatyouneed": "Let  verified  suppliers find you.\nJust tell us what you need！",
                "feedback.msgsend.control.msgContent.msg.must": "Please enter your message",
                "feedback.msgsend.getquatation": "Get Quotation Now!",
                "feedback.msgsend.control.industry.tip": "Supplier may need this information to provide appropriate quotation.",
                "feedback.msgsend.control.tipContent.view.sample": "View Sample",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "Your inquiry has been sent successfully to the supplier.",
                "feedback.msgsend.control.add": "Add",
                "feedback.msgsend.screen.memberInquiry.to": "To",
                "feedback.msgsend.control.sku.limit": "Please enter between 1 - 20 characters",
                "feedback.msgsend.control.reply.within": "Reply me within",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Recommend matching suppliers if this supplier doesn’t contact me on Message Center within 24 hours.",
                "feedback.msgsend.screen.inquiry.from": "From",
                "feedback.msgsend.control.multilang.commit": "Contact Supplier",
                "feedback.msgsend.screen.inquiry.message": "Message",
                "feedback.msgsend.control.msgQuantity.limit.number": "Please enter a number.",
                "feedback.msgsend.control.msgQuantity.quantity": "Quantity",
                "feedback.msgsend.screen.inquiry.message.info": "Enter your inquiry details such as product name, color, size, MOQ, FOB, etc.",
                "feedback.msgsend.control.msgQuantity.limit.between": "Please enter between 1 - 999999",
                "commons.button.submit": "Submit"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "de-de": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "Stunden",
                "feedback.msgsend.screen.memberInquiry.to": "An",
                "feedback.msgsend.control.sku.limit": "Geben Sie bitte zwischen 1 bis 20 Zeichen ein",
                "feedback.msgsend.control.reply.within": "Bitte antworten Sie bis",
                "feedback.msgsend.control.stickLogin.email.must": "Geben Sie E-Mail.",
                "feedback.msgsend.control.fill.requirement": "Schreiben Sie bitte hier Ihre Anforderung.",
                "msgsend.control.mcSuccess.contactSupplier": "Lieferant kontaktieren",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Ihre Nachricht muss zwischen 20-8000 Buchstaben sein",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Bitte empfehlen Sie mir weitere ausgewählte Anbieter, sollte dieser Anbieter mich nicht in den nächsten 24 Stunden über das \"Nachrichten-Center\" kontaktieren.",
                "feedback.msgsend.control.privacy": "Ich bin einverstanden, meine  <span class=\"stress\">Geschäftskarte</span> mit den Lieferanten zu teilen.",
                "feedback.msgsend.control.multilang.commit": "Kontakt mit Lieferant aufnehmen",
                "feedback.msgsend.screen.inquiry.from": "Von",
                "feedback.msgsend.screen.inquiry.message": "Nachricht",
                "feedback.msgsend.whatyouneed": "Lassen Sie sich von passenden überprüften Lieferanten finden.\nSagen Sie uns einfach, was Sie brauchen!",
                "feedback.msgsend.control.msgContent.msg.must": "Bitte Ihre Nachricht eingeben",
                "feedback.msgsend.getquatation": "Angebote Ansehen",
                "feedback.msgsend.control.msgQuantity.limit.number": "Bitte geben Sie eine Nummer ein.",
                "feedback.msgsend.control.msgQuantity.quantity": "Menge",
                "feedback.msgsend.screen.inquiry.message.info": "Geben Sie Ihre Anfrage-Information ein, wie Produktsname, Farbe, Größe, Mindestbestellmengen, FOB-Preis u.s.w.",
                "feedback.msgsend.control.msgQuantity.limit.between": "Bitte eingeben zwischen 1-999999",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "Ihre Anfrage wurde dem Lieferant mit Erfolg gesendet.",
                "feedback.msgsend.control.tipContent.view.sample": "Beispiel anschauen",
                "feedback.msgsend.control.add": "hinzufügen",
                "commons.button.submit": "Vorlegen"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "in-id": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "Ke",
                "feedback.msgsend.control.stickLogin.email.must": "Masukkan email atau ID Anggota.",
                "msgsend.control.mcSuccess.contactSupplier": "Hubungi Supplier",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Pesan Anda harus antara 20-8000 karakter",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Rekomendasikan supplier yang sesuai jika supplier ini tidak menghubungi saya di Pusat Pesan dalam 24 jam.",
                "feedback.msgsend.control.privacy": "Saya setuju untuk membagi  <span class=\"stress\">Kartu Nama</span> saya dengan supplier.",
                "feedback.msgsend.screen.inquiry.from": "Dari",
                "feedback.msgsend.whatyouneed": "Biarkan supplier terverifikasi menemukan Anda. Cukup katakan apa yang Anda butuhkan！",
                "feedback.msgsend.screen.inquiry.message": "pesan",
                "feedback.msgsend.control.msgContent.msg.must": "Mohon masukkan pesan Anda",
                "feedback.msgsend.control.msgQuantity.limit.number": "Mohon masukkan angka.",
                "feedback.msgsend.control.msgQuantity.quantity": "Jumlah",
                "feedback.msgsend.screen.inquiry.message.info": "Masukkan rincian pertanyaan Anda seperti nama produk, warna, ukuran, MOQ, FOB, dsb.",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "Pertanyaan Anda berhasil dikirim ke supplier.",
                "feedback.msgsend.control.tipContent.view.sample": "Lihat Sampel",
                "commons.button.submit": "Kirim"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "it-it": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "ore",
                "feedback.msgsend.control.stickLogin.email.must": "Inserisci email.",
                "feedback.msgsend.control.fill.requirement": "Scrivere qui le vostre richieste.",
                "msgsend.control.mcSuccess.contactSupplier": "Contattare il fornitore",
                "feedback.msgsend.control.msgContent.msg.char.limit": "I tuoi messaggi deve essere tra 20—8000 caratteri.",
                "feedback.msgsend.control.privacy": "Acconsento a condividere la mia <span class=\"stress\">Business Card</span>  con i(l) fornitori(e).",
                "feedback.msgsend.whatyouneed": "Lascia che i fornitori che cerchi ti trovino. \r\nTi basta dirci di che cosa hai bisogno!",
                "feedback.msgsend.control.msgContent.msg.must": "Inserisci il tuo messaggio",
                "feedback.msgsend.getquatation": "Ottieni Preventivi",
                "feedback.msgsend.control.industry.tip": "Il venditore potrebbe aver bisogno di queste informazioni per fare un preventivo preciso.",
                "feedback.msgsend.control.tipContent.view.sample": "Visualizza esempio",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "La tua ricerca è stata inviata con successo al fornitore.",
                "feedback.msgsend.control.add": "Aggiungi",
                "feedback.msgsend.screen.memberInquiry.to": "A",
                "feedback.msgsend.control.sku.limit": "Immettere tra 1 - 20 caratteri",
                "feedback.msgsend.control.reply.within": "Rispondere entro",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Per favore consigliatemi altri fornitori selezionati se questo fornitore non mi contatta nel \"centro messaggi\" entro 24 ore.",
                "feedback.msgsend.screen.inquiry.from": "Da",
                "feedback.msgsend.control.multilang.commit": "Contatta il fornitore",
                "feedback.msgsend.screen.inquiry.message": "Messaggio",
                "feedback.msgsend.control.msgQuantity.limit.number": "Si prega di inserire un numero.",
                "feedback.msgsend.control.msgQuantity.quantity": "Quantità",
                "feedback.msgsend.screen.inquiry.message.info": "Inserisci l'informazione della richietsa, come il nome dei prodotti, il colore, la dimensione, la quantità  minima di ordine, il prezzo di FOB ecc.",
                "feedback.msgsend.control.msgQuantity.limit.between": "immettere tra 1 - 999999",
                "commons.button.submit": "Presenti"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "fr-fr": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "heures",
                "feedback.msgsend.control.stickLogin.email.must": "Entrez e-mail.",
                "feedback.msgsend.control.fill.requirement": "Veuillez écrire vos besoins ici.",
                "msgsend.control.mcSuccess.contactSupplier": "Contacter le Fournisseur",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Votre message doit être compris entre 20-8000 caractères",
                "feedback.msgsend.control.privacy": "Je suis d'accord pour partager ma <span class=\"stress\">Carte de Visite</span> avec le(s) fournisseur(s).",
                "feedback.msgsend.whatyouneed": "Laissez les fournisseurs vérifiés correspondants vous trouver. \nDites-nous seulement ce dont vous avez besoin!",
                "feedback.msgsend.control.msgContent.msg.must": "S'il vous plaît entrez votre message",
                "feedback.msgsend.getquatation": "Obtenez des devis",
                "feedback.msgsend.control.industry.tip": "Le fournisseur peut avoir besoin de cette information pour envoyer une quotation plus précis.",
                "feedback.msgsend.control.tipContent.view.sample": "Visionner un échantillon",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "Votre demande a bien été envoyé au fournisseur.",
                "feedback.msgsend.control.add": "Ajouter",
                "feedback.msgsend.screen.memberInquiry.to": "à",
                "feedback.msgsend.control.sku.limit": "Veuillez saisir entre 1 et 20 caractères",
                "feedback.msgsend.control.reply.within": "Répondez-moi dans",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Me recommander davantage de fournisseurs sélectionnés si ce fournisseur ne me contacte pas sur le Centre de messages dans les 24 heures.",
                "feedback.msgsend.screen.inquiry.from": "De",
                "feedback.msgsend.control.multilang.commit": "Contactez le fournisseur",
                "feedback.msgsend.screen.inquiry.message": "Message",
                "feedback.msgsend.control.msgQuantity.limit.number": "Entrez le numéro.",
                "feedback.msgsend.control.msgQuantity.quantity": "Quantité",
                "feedback.msgsend.screen.inquiry.message.info": "Informations d'appel d'offre a entrer,par exemple: nom de produit, couleur,dimensions de produit quantite minimale de commande, prix FOB etc",
                "feedback.msgsend.control.msgQuantity.limit.between": "Veuillez saisir entre 1 et 999999",
                "commons.button.submit": "Soumettre"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "iw-il": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "אל",
                "feedback.msgsend.control.stickLogin.email.must": "הזינו דוא\"ל או מספר זיהוי חבר",
                "msgsend.control.mcSuccess.contactSupplier": "צרו קשר עם הספק",
                "feedback.msgsend.control.msgContent.msg.char.limit": "ההודעה שלכם צריכה להכיל 8,000-20 תווים",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "המלץ ספקים מתאימים אם ספק זה לא יוצר עימי קשר במרכז הודעות תוך 24 שעות.",
                "feedback.msgsend.control.privacy": "אני מסכימ/ה לשתף את</span> כרטיס הביקור<span class=\"stress\"> שלי עם הספק(ים).",
                "feedback.msgsend.screen.inquiry.from": "מ",
                "feedback.msgsend.whatyouneed": "תנו לספקים מורשים למצוא אתכם. רק ספרו לנו מה אתם צריכים!",
                "feedback.msgsend.screen.inquiry.message": "הודעה",
                "feedback.msgsend.control.msgContent.msg.must": "בבקשה הזינו את ההודעה שלכם",
                "feedback.msgsend.control.msgQuantity.limit.number": "בבקשה הכניסו מספר.",
                "feedback.msgsend.control.msgQuantity.quantity": "כמות",
                "feedback.msgsend.screen.inquiry.message.info": "הזינו את פרטי השאילתא שלנו, כמו שם המוצר, צבע, גודל, MOQ, FOB ועוד.",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "הודעתך נשלחה בהצלחה לספק.",
                "feedback.msgsend.control.tipContent.view.sample": "ראה דוגמא",
                "commons.button.submit": "הגש"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "ja-jp": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "時間",
                "feedback.msgsend.control.stickLogin.email.must": "メールアドレスを入力してください．",
                "feedback.msgsend.control.fill.requirement": "ご要望をここにご記入ください。",
                "msgsend.control.mcSuccess.contactSupplier": "サプライヤーにお問い合わせ",
                "feedback.msgsend.control.msgContent.msg.char.limit": "メッセージ内容は、20～8000文字にしてください",
                "feedback.msgsend.control.privacy": "サプライヤーに<span class=\"stress\">名刺</span>をシェアすることに承諾します。",
                "feedback.msgsend.whatyouneed": "認定サプライヤーマッチングに見つけてもらいましょう。\n必要なものを伝えるだけです！",
                "feedback.msgsend.control.msgContent.msg.must": "メッセージ内容を入力してください",
                "feedback.msgsend.getquatation": "見積取得",
                "feedback.msgsend.control.industry.tip": "サプライヤーから適切な見積もりを提供できるように、これらの情報が必要です。",
                "feedback.msgsend.control.tipContent.view.sample": "サンプルを見る",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "あなたの問い合わせは成功にサプライヤーに送信しました。",
                "feedback.msgsend.control.add": "追加",
                "feedback.msgsend.screen.memberInquiry.to": "受取人",
                "feedback.msgsend.control.sku.limit": "内容は1-20文字にしてください。",
                "feedback.msgsend.control.reply.within": "以内に返事してください",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "このサプライヤーが24時間内に｢メッセージセンター｣へ連絡していない場合は、他の厳選したサプライヤーをマッピングしてお勧めます。",
                "feedback.msgsend.screen.inquiry.from": "差出人",
                "feedback.msgsend.control.multilang.commit": "お問い合わせ",
                "feedback.msgsend.screen.inquiry.message": "メッセージ",
                "feedback.msgsend.control.msgQuantity.limit.number": "数字を入力してください。",
                "feedback.msgsend.control.msgQuantity.quantity": "数量",
                "feedback.msgsend.screen.inquiry.message.info": "お問合せ情報をご入力ください。たとえば、製品名、色、寸法、最低注文量、FOB価格など",
                "feedback.msgsend.control.msgQuantity.limit.between": "1-999999で入力してください",
                "commons.button.submit": "提出する"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "ko-kr": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "시간",
                "feedback.msgsend.screen.memberInquiry.to": "수신자",
                "feedback.msgsend.control.sku.limit": "1-20개사이의 문자를 입력하십시오",
                "feedback.msgsend.control.reply.within": "내에 회신하십시오",
                "feedback.msgsend.control.stickLogin.email.must": "이메일을 입력합니다.",
                "feedback.msgsend.control.fill.requirement": "여기에 귀하의 요구사항을 작성하십시오.",
                "msgsend.control.mcSuccess.contactSupplier": "문의하기",
                "feedback.msgsend.control.msgContent.msg.char.limit": "메시지 내용은 20-8000자 여야 합니다",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "이 공급자가 24시간 이내에 '메시지 센터'로 연락하지 않을 경우, 보다 엄선된 공급자를 추천해 주세요.",
                "feedback.msgsend.control.privacy": "공급업체(들)에게 내 <span class=\"stress\">명함을</span> 공유하는데 동의합니다.",
                "feedback.msgsend.control.multilang.commit": "구매자와 연락",
                "feedback.msgsend.screen.inquiry.from": "송신자",
                "feedback.msgsend.screen.inquiry.message": "메시지",
                "feedback.msgsend.whatyouneed": "조건에 맞는 인증 공급자를 찾아 드리겠습니다.\n저희에게 말씀만 해주세요!",
                "feedback.msgsend.control.msgContent.msg.must": "귀하의 메시지를 입력하십시오.",
                "feedback.msgsend.getquatation": "견적 받기",
                "feedback.msgsend.control.msgQuantity.limit.number": "숫자를 입력해 주십시오.",
                "feedback.msgsend.control.msgQuantity.quantity": "수량",
                "feedback.msgsend.screen.inquiry.message.info": "당신의 견적조회 정보를 입력해 주세요. 예하면 제품명칭, 칼라, 규격, 최소 주문량, FOB가격 등",
                "feedback.msgsend.control.msgQuantity.limit.between": "1 - 999999를 입력하십시오",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "문의사항이 공급자한테 성공적으로 발송 되었습니다.",
                "feedback.msgsend.control.tipContent.view.sample": "샘플 보기",
                "feedback.msgsend.control.add": "추가",
                "commons.button.submit": "제출"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "ru-ru": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "Часов",
                "feedback.msgsend.screen.memberInquiry.to": "Кому",
                "feedback.msgsend.control.sku.limit": "Пожалуйста введите от 1 до 20 символов",
                "feedback.msgsend.control.reply.within": "Ответьте мне в течение",
                "feedback.msgsend.control.stickLogin.email.must": "Введите e-mail.",
                "feedback.msgsend.control.fill.requirement": "Пожалуйста, напишите ваши требования здесь.",
                "msgsend.control.mcSuccess.contactSupplier": "Отправить сообщение",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Ваше сообщение должно быть в пределах 20-8000 символов",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Рекомендовать похожих поставщиков, если этот поставщик не ответил в течении 24 ч.\n",
                "feedback.msgsend.control.privacy": "Я согласен поделиться своей  <span class=\"stress\">бизнес-карточкой</span> с поставщиком (ми)",
                "feedback.msgsend.control.multilang.commit": "Отправить сообщение",
                "feedback.msgsend.screen.inquiry.from": "От",
                "feedback.msgsend.screen.inquiry.message": "Сообщение",
                "feedback.msgsend.whatyouneed": "Позвольте подходящим проверенным поставщикам найти вас.\nПросто скажите нам, что вам нужно！",
                "feedback.msgsend.control.msgContent.msg.must": "Введите ваше сообщение",
                "feedback.msgsend.getquatation": "Получить расценки",
                "feedback.msgsend.control.msgQuantity.limit.number": "Пожалуйста введите число.",
                "feedback.msgsend.control.msgQuantity.quantity": "Количество",
                "feedback.msgsend.screen.inquiry.message.info": "Введите детали вашего запроса, например, название товара, цвет, размер, минимальное количество заказа, цену FOB и т. д.",
                "feedback.msgsend.control.msgQuantity.limit.between": "Пожалуйста, введите в пределе от 1 до 999999",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "Ваш запрос успешно отправлен поставщику.",
                "feedback.msgsend.control.tipContent.view.sample": "Посмотреть образец",
                "feedback.msgsend.control.add": "Добавить",
                "commons.button.submit": "представить"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "pt-pt": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "horas",
                "feedback.msgsend.control.stickLogin.email.must": "Insira o e-mail ou ID de usuário",
                "feedback.msgsend.control.fill.requirement": "Por favor, insira seus requisitos aqui.",
                "msgsend.control.mcSuccess.contactSupplier": "Contatar fornecedor",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Sua mensagem deve ter de 2 a 8.000 caracteres",
                "feedback.msgsend.control.privacy": "Eu concordo em partilhar o meu <span class=\"stress\"> Cartão de Visita</span> com o(s) fornecedor (es).",
                "feedback.msgsend.whatyouneed": "Deixe que fornecedores apropriados verificados te encontrem. \nApenas nos diga o que você precisa!",
                "feedback.msgsend.control.msgContent.msg.must": "Por favor, escreva sua mensagem",
                "feedback.msgsend.getquatation": "Solicitar Cotações",
                "feedback.msgsend.control.industry.tip": "O fornecedor pode necessitar esta informação para enviar uma cotação mais precisa.",
                "feedback.msgsend.control.tipContent.view.sample": "Ver exemplo",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "A sua solicitação foi enviada ao fornecedor com sucesso.",
                "feedback.msgsend.control.add": "Adicionar",
                "feedback.msgsend.screen.memberInquiry.to": "Para",
                "feedback.msgsend.control.sku.limit": "Por favor, insira de 1 a 20 caracteres",
                "feedback.msgsend.control.reply.within": "Responda-me dentro de",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Por favor, me recomende outros fornecedores caso este entre em contato comigo através da \"Central de mensagens\" em menos de 24 horas.",
                "feedback.msgsend.screen.inquiry.from": "De",
                "feedback.msgsend.control.multilang.commit": "Contatar Fornecedor",
                "feedback.msgsend.screen.inquiry.message": "Mensagem",
                "feedback.msgsend.control.msgQuantity.limit.number": "Por favor, insira um número.",
                "feedback.msgsend.control.msgQuantity.quantity": "Quantidade",
                "feedback.msgsend.screen.inquiry.message.info": "Insira os detalhes da sua consulta, como nome do produto, cor, tamanho, quantidade mínima, preço FOB, etc.",
                "feedback.msgsend.control.msgQuantity.limit.between": "Por favor, insira de 1 a 999.999 caracteres",
                "commons.button.submit": "Enviar"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "nl-nl": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "uren",
                "feedback.msgsend.screen.memberInquiry.to": "Aan",
                "feedback.msgsend.control.sku.limit": "Geef tussen de 1-20 tekens in",
                "feedback.msgsend.control.reply.within": "Beantwoord me binnen",
                "feedback.msgsend.control.stickLogin.email.must": "Voer e-mail of lidmaatschap-ID in.",
                "feedback.msgsend.control.fill.requirement": "Noteer hier alsjeblieft uw vereiste.",
                "msgsend.control.mcSuccess.contactSupplier": "Leverancier",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Uw bericht moet tussen 20-8000 tekens zijn",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Beveel passende leveranciers aan als deze leverancier geen contact met mij opneemt op berichtencentrum binnen 24 uur.",
                "feedback.msgsend.control.privacy": "Ik ga akkoord om mijn <span class=\"stress\">visitekaartje</span> met de leverancier(s) te delen.",
                "feedback.msgsend.control.multilang.commit": "Contacteer leverancier",
                "feedback.msgsend.screen.inquiry.from": "Van",
                "feedback.msgsend.screen.inquiry.message": "bericht",
                "feedback.msgsend.whatyouneed": "\"Laat gecertificeerde leveranciers u vinden.",
                "feedback.msgsend.control.msgContent.msg.must": "Voer uw bericht in",
                "feedback.msgsend.getquatation": "Krijg offertes",
                "feedback.msgsend.control.msgQuantity.limit.number": "Voer een getal in.",
                "feedback.msgsend.control.msgQuantity.quantity": "Hoeveelheid",
                "feedback.msgsend.screen.inquiry.message.info": "Vul uw aanvraag details zoals naam van het product, kleur, grootte, MOQ, FOB, etc.",
                "feedback.msgsend.control.msgQuantity.limit.between": "Geef tussen 1-999999 in",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "Uw aanvraag word aan de leverancier met succes gestuurd.",
                "feedback.msgsend.control.tipContent.view.sample": "Bekijk voorbeeld",
                "feedback.msgsend.control.add": "Voeg Toe",
                "commons.button.submit": "Indienen"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "th-th": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "ชั่วโมง",
                "feedback.msgsend.screen.memberInquiry.to": "ถึง",
                "feedback.msgsend.control.sku.limit": "กรุณาใส่ ระหว่าง 1 - 20 ตัวอักษร",
                "feedback.msgsend.control.reply.within": "ตอบฉันภายใน",
                "feedback.msgsend.control.stickLogin.email.must": "ใส่อีเมล์หรือเลขสมาชิก",
                "feedback.msgsend.control.fill.requirement": "กรุณาใส่ความต้องการของคุณที่",
                "msgsend.control.mcSuccess.contactSupplier": "ติดต่อซัพพลายเออร์",
                "feedback.msgsend.control.msgContent.msg.char.limit": "ข้อความของคุณต้องยาวระหว่าง 20-8000 ตัวอักษร",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "กรุณาแนะนำผู้ขายรายอื่นๆ เพิ่มเติมหากผู้ขายรายนี้ไม่ติดต่อฉันผ่าน \"ศูนย์รวมข้อความ\" ภายใน 24 ชั่วโมง",
                "feedback.msgsend.control.privacy": "ฉันตกลงที่จะแชร์<span class=\"stress\">นามบัตรกั</span>บผู้ขาย",
                "feedback.msgsend.control.multilang.commit": "ติดต่อผู้ขาย",
                "feedback.msgsend.screen.inquiry.from": "จาก",
                "feedback.msgsend.screen.inquiry.message": "ข้อความ",
                "feedback.msgsend.whatyouneed": "ให้ผู้ขายที่ได้รับการยืนยันแล้วมาหาคุณเอง\nแค่บอกกับเราถึงสิ่งที่คุณต้องการ",
                "feedback.msgsend.control.msgContent.msg.must": "โปรดใส่ข้อความของคุณ",
                "feedback.msgsend.getquatation": "ขอใบเสนอราคา",
                "feedback.msgsend.control.msgQuantity.limit.number": "โปรดใส่ตัวเลข",
                "feedback.msgsend.control.msgQuantity.quantity": "จำนวน",
                "feedback.msgsend.screen.inquiry.message.info": "ใส่รายละเอียดใบสอบถามราคา เช่น ชื่อสินค้า สี ขนาด MOQ FOB ฯลฯ",
                "feedback.msgsend.control.msgQuantity.limit.between": "กรุณาใส่เลขระหว่าง 1 - 999999",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "การสอบถามข้อมูลของคุณถูกส่งไปยังผู้ขายสำเร็จแล้ว",
                "feedback.msgsend.control.tipContent.view.sample": "ดูตัวอย่าง",
                "feedback.msgsend.control.add": "เพิ่ม",
                "commons.button.submit": "ส่ง"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "vi-vn": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "giờ",
                "feedback.msgsend.screen.memberInquiry.to": "Tới",
                "feedback.msgsend.control.sku.limit": "Vui lòng nhập trong khoảng 1 - 20 ký tự",
                "feedback.msgsend.control.reply.within": "Trả lời tôi trong vòng",
                "feedback.msgsend.control.stickLogin.email.must": "Nhập thư điện tử hoặc ID Thành viên",
                "feedback.msgsend.control.fill.requirement": "Vui lòng viết yêu cầu của bạn ở đây.",
                "msgsend.control.mcSuccess.contactSupplier": "Liên hệ nhà cung cấp",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Tin nhắn của bạn phải có từ 20 đến 8000 ký tự",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Vui lòng giới thiệu thêm các nhà cung cấp được lựa chọn nếu nhà cung cấp này không liên hệ với tôi tại 'trung tâm thông báo' trong 24 giờ.",
                "feedback.msgsend.control.privacy": "Tôi đồng ý chia sẻ <span class=\"stress\">Danh thiếp của</span> tôi với (các) nhà cung cấp.",
                "feedback.msgsend.control.multilang.commit": "Liên hệ với nhà cung cấp",
                "feedback.msgsend.screen.inquiry.from": "Từ",
                "feedback.msgsend.screen.inquiry.message": "Lời nhắn",
                "feedback.msgsend.whatyouneed": "Hãy để cho các nhà cung cấp đã xác minh phù hợp tìm ra bạn.\nChỉ cần nói cho chúng tôi điều bạn cần!",
                "feedback.msgsend.control.msgContent.msg.must": "Vui lòng nhập tin nhắn",
                "feedback.msgsend.getquatation": "Nhận báo giá",
                "feedback.msgsend.control.msgQuantity.limit.number": "Vui lòng nhập 1 số.",
                "feedback.msgsend.control.msgQuantity.quantity": "Số lượng",
                "feedback.msgsend.screen.inquiry.message.info": "Nhập thông tin yêu cầu của bạn như tên sản phẩm, màu sắc, kích thước, MOQ, FOB, vv.",
                "feedback.msgsend.control.msgQuantity.limit.between": "Vui lòng nhập trong khoảng 1 - 999999",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "Yêu cầu của bạn đã được gửi tới nhà cung cấp thành công.",
                "feedback.msgsend.control.tipContent.view.sample": "Xem mẫu",
                "feedback.msgsend.control.add": "Thêm vào",
                "commons.button.submit": "Gửi đi"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "tr-tr": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "saatler",
                "feedback.msgsend.screen.memberInquiry.to": "Hedef",
                "feedback.msgsend.control.sku.limit": "Lütfen 1-20 arasında karakter girin.",
                "feedback.msgsend.control.reply.within": "Bana şu kadar zaman içinde yanıt verin",
                "feedback.msgsend.control.stickLogin.email.must": "Eposta yada Üye Adını girin.",
                "feedback.msgsend.control.fill.requirement": "Lütfen buraya ihtiyacınızı yazın.",
                "msgsend.control.mcSuccess.contactSupplier": "Tedarikçiyle İrtibat kurun",
                "feedback.msgsend.control.msgContent.msg.char.limit": "İletiniz 20-8000 karakter arasında olmalıdır",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Bu tedarikçi benimle 'mesaj merkezi' üzerinden 24 saat içinde iletişime geçmezse, lütfen daha fazla seçilmiş tedarikçi önerin.",
                "feedback.msgsend.control.privacy": "<span class=\"stress\">Kartviziti</span> mi tedarikçi(ler)le paylaşmayı kabul ediyorum.",
                "feedback.msgsend.control.multilang.commit": "Tedarikçi ile görüşün.",
                "feedback.msgsend.screen.inquiry.from": "Buradan",
                "feedback.msgsend.screen.inquiry.message": "İleti",
                "feedback.msgsend.whatyouneed": "Eşleşmiş Onaylanmış tedarikçierin seni bulmasına izin ver. Bize sadece neye ihtiyacın olduğunu söyle!",
                "feedback.msgsend.control.msgContent.msg.must": "Lütfen iletinizi girin",
                "feedback.msgsend.getquatation": "Fiyatları Al",
                "feedback.msgsend.control.msgQuantity.limit.number": "Lütfen bir sayı girin.",
                "feedback.msgsend.control.msgQuantity.quantity": "Miktar",
                "feedback.msgsend.screen.inquiry.message.info": "Ürün adı, renk, boyut, MSM, FOB gibi talep detaylarınızı girin.",
                "feedback.msgsend.control.msgQuantity.limit.between": "Lütfen 1 - 999999 arasında girin.",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "Sorgulamanız tedarikçiye başarılı bir şekilde gönderildi.",
                "feedback.msgsend.control.tipContent.view.sample": "Örneği Görüntüle",
                "feedback.msgsend.control.add": "Ekle",
                "commons.button.submit": "Gönder"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "zh-cn": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "小时",
                "feedback.msgsend.screen.memberInquiry.to": "To",
                "feedback.msgsend.control.sku.limit": "请输入20个以内的字符",
                "feedback.msgsend.control.reply.within": "期待回复时间",
                "feedback.msgsend.control.stickLogin.email.must": "Enter email or Member ID.",
                "feedback.msgsend.control.fill.requirement": "请填写你的需求",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Your message must be between 20-8000 characters",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Please recommend more selected suppliers if this supplier doesn’t contact me on 'message center' in 24 hours.",
                "feedback.msgsend.control.multilang.commit": "发送信息",
                "feedback.msgsend.screen.inquiry.from": "From",
                "feedback.msgsend.screen.inquiry.message": "Message",
                "feedback.msgsend.control.msgContent.msg.must": "Please enter your message",
                "feedback.msgsend.control.industry.tip": "提供这些信息可以帮助供应商做出更准确的报价。",
                "feedback.msgsend.control.msgQuantity.limit.number": "Please enter a number.",
                "feedback.msgsend.control.msgQuantity.quantity": "Quantity",
                "feedback.msgsend.screen.inquiry.message.info": "输入您的询盘信息，例如产品名称、颜色、尺寸、最小起订量、FOB价等",
                "feedback.msgsend.control.msgQuantity.limit.between": "请填入1-999999之间的值",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "Your inquiry has been sent successfully to the supplier.",
                "feedback.msgsend.control.tipContent.view.sample": "View sample",
                "feedback.msgsend.control.add": "添加",
                "commons.button.submit": "提交"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "zh-tw": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.control.hours": "小時",
                "feedback.msgsend.screen.memberInquiry.to": "To",
                "feedback.msgsend.control.sku.limit": "請輸入20個以內的字符",
                "feedback.msgsend.control.reply.within": "期待回復時間",
                "feedback.msgsend.control.stickLogin.email.must": "Enter email or Member ID.",
                "feedback.msgsend.control.fill.requirement": "請填寫您的需求",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Your message must be between 20-8000 characters",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Please recommend more selected suppliers if this supplier doesn’t contact me on 'message center' in 24 hours.",
                "feedback.msgsend.control.multilang.commit": "送出信息",
                "feedback.msgsend.screen.inquiry.from": "From",
                "feedback.msgsend.screen.inquiry.message": "Message",
                "feedback.msgsend.control.msgContent.msg.must": "Please enter your message",
                "feedback.msgsend.control.industry.tip": "提供這些咨詢可以幫助供應商做出更准確的報價。",
                "feedback.msgsend.control.msgQuantity.limit.number": "Please enter a number.",
                "feedback.msgsend.control.msgQuantity.quantity": "Quantity",
                "feedback.msgsend.screen.inquiry.message.info": "輸入詢問板材信息的您，例如產品範圍，顏色，大小，是最小的訂閱數量， FOB價格等等",
                "feedback.msgsend.control.msgQuantity.limit.between": "請填入1-999999之間的值",
                "feedback.msgsend.control.mcSuccess.popupsuc.sidebar.sendsuc": "Your inquiry has been sent successfully to the supplier.",
                "feedback.msgsend.control.tipContent.view.sample": "View sample",
                "feedback.msgsend.control.add": "添加",
                "commons.button.submit": "送出"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })()
};

function _(locale) {
    var r = i18n[map[locale] || 'en-us'];
    r._ = _;
    return r;
}
try {
    var locale = seajs.data.vars.locale;
} catch (e) {
    var locale = 'en-us';
}
module.exports = _(locale);
